<!--我的众筹.关注-->
<template>
  <div class="fragment-crowdfunding-follow">
    <div class="fragment-crowdfunding-follow__container">
      <div v-for="(item,index) in items" class="fragment-crowdfunding-follow__container-item">
        <div class="fragment-crowdfunding-follow__container-item-divider"></div>
        <item-crowdfunding-mine class="fragment-crowdfunding-follow__container-item-content" v-bind:item="item"
                                v-bind:tabindex="1">

        </item-crowdfunding-mine>
      </div>

    </div>

  </div>
</template>

<script>
import ItemCrowdfundingMine from '../item/index';
import { crowdfollowLadderList as follwList } from 'apis/crowdfunding';

export default {
  name: 'fragment-crowdfunding-follow',
  components: { ItemCrowdfundingMine },
  props: {
    items: Array,
  },
  data() {
    return {
      loading: false, // 是否正在加载
      disableLoad: false, // 是能继续加载
      list: [],
      page: 1,
      totalPages: 1,
    };
  },
  mounted() {
    // this.pageList();
  },
  methods: {
    async pageList() {
      try {
        this.loading = true;
        const data = await follwList({ p: this.page, limit: 5 });
        if (data) {
          this.totalPages = data.pager.totalPages;
          this.list = [...this.list, ...data.list];
        }
      } catch (e) {
        const { message } = e;
        console.error(`获取关注列表失败:${message}`, e.toString());
      } finally {
        this.loading = false;
      }
    },
    loadMore() {
      if (this.totalPages > this.page) {
        this.page++;
        this.pageList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$divider-height: 20px;
.fragment-crowdfunding-follow {
  width: 100%;

  &__container {
    width: 100%;
    //margin-bottom:$divider-height;
    &-item {
      width: 100%;
      margin: 0 auto;

      &-divider {
        width: 100%;
        height: $divider-height;
        background-color: transparent;
      }

      &-content {
        margin: 0 auto;
      }
    }
  }

  padding-bottom: 110px;
}
</style>
